import type { ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'

import { Loader } from '@twistopayments/design-system/components/atoms/loader'

import type { OnboardingHeaders } from '@twisto/risk'
import { getOnboardingHeaders } from '@twisto/risk'

import { RiskHeadersContext } from './risk-headers.context'

type Props = {
  children: ReactNode
}

export const RiskHeadersProvider = ({ children }: Props) => {
  const [riskHeaders, setRiskHeaders] = useState<OnboardingHeaders | null>(null)
  const wereRiskHeadersSet = useRef(false)

  // TODO - this should be get from BE
  const sidUrl = 'https://api.twisto.cz/sid.png'

  useEffect(() => {
    if (wereRiskHeadersSet.current === false) {
      const computeHeaders = async () => {
        const headers = await getOnboardingHeaders({ sidUrl })
        setRiskHeaders(headers)
      }

      computeHeaders()

      return () => {
        wereRiskHeadersSet.current = true
      }
    }
  }, [])

  if (riskHeaders == null) {
    return <Loader />
  }

  return (
    <RiskHeadersContext.Provider value={riskHeaders}>
      {children}
    </RiskHeadersContext.Provider>
  )
}
